export default "__VITE_ASSET__DmGLhzBP__"